import { type ServiceError } from 'gpcore-apikit/grpc/types';
import { useImageStore } from 'gpcore-apikit/store/pinia/image';
import type { BasicImage, Image, OperatingSystem } from 'gpcore-grpc/gpcore/api/cloud/v1/image_pb';
import type { CloudProviderType } from 'gpcore-grpc/gpcore/type/v1/cloud_provider_pb';
import useNotifications from 'gpcore-uikit/composables/useNotifications';
import { ref, shallowRef } from 'vue';

export default () => {
  const isLoading = ref(false);
  const imageStore = useImageStore();
  const data = shallowRef<Array<OperatingSystem>>([]);

  const selectedOs = ref<OperatingSystem | null>(null);
  const selectedOsImageId = ref<string | null>(null);

  const findPublicImageFromSource = (image: BasicImage | Image, source: Array<OperatingSystem>) => {
    if (image == null) {
      return null;
    }

    for (let index = 0; index < source.length; index += 1) {
      const os = source[index];
      const img = os.images.find((img) => img.id === image.id);

      if (img != null) {
        selectedOs.value = os;
        selectedOsImageId.value = img.id;
        return img;
      }
    }

    return null;
  };
  const findPublicImage = (image: BasicImage | Image) => {
    return findPublicImageFromSource(image, data.value);
  };

  const { addNotification } = useNotifications();
  const error = ref<Error>();
  const fetch = async (cloudProviderType?: CloudProviderType | null) => {
    isLoading.value = true;
    data.value = [];
    selectedOs.value = null;
    selectedOsImageId.value = null;
    error.value = undefined;

    try {
      const response = await imageStore.reloadPublicImages(cloudProviderType);
      data.value = response.operatingSystems;
    } catch (e) {
      addNotification({
        message: (e as ServiceError).message,
        type: 'danger',
      });

      error.value = e as Error;
    } finally {
      isLoading.value = false;
    }
  };

  return {
    isLoading: isLoading,
    data,
    selectedOs,
    selectedOsImageId,
    findPublicImage,
    findPublicImageFromSource,
    fetch,
    error,
  };
};
